import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from "../../components/custom/Search";


interface SearchInputProps {
    search: (filter: object) => any;
    form?: any;
}

export const ActiveTypeOption = [
    {
        value: 1,
        label: <FormattedMessage id="app.active" defaultMessage={`Active`}/>,

    },
    {
        value: 0,
        label: <FormattedMessage id="app.inactive" defaultMessage={`Inactive`}/>,
    }
];

const SearchChannelsComponent: React.FC<SearchInputProps> = (props) => {
    const {search} = props;

    const inputs = [
        {
            name: "query",
            label: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
            type: SearchInputType.TEXT,
            size: 12
        },
        {
            name: "is_active",
            label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
            type: SearchInputType.SELECT,
            options: ActiveTypeOption,
            size: 12
        }
    ];

    return <Search inputs={inputs} search={search}/>

};

export default SearchChannelsComponent;
